"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractPreviewService = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var validate_iban_1 = require("@src/const/forms/validate-iban");
var infrastructure_const_1 = require("@src/const/infrastructure.const");
var input_output_module_const_1 = require("@src/const/input-output-module.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var backend_services_1 = require("@src/services/backend-services");
var payment_const_1 = require("../const/payment.const");
function initElement(moduleClass, config) {
    var _a, _b, _c;
    var container = (_c = (_b = (_a = moduleClass.module) === null || _a === void 0 ? void 0 : _a.references) === null || _b === void 0 ? void 0 : _b.contractPreviewDownload) === null || _c === void 0 ? void 0 : _c.domElement;
    if (container === null || container === void 0 ? void 0 : container.length) {
        container.on('click', function () {
            console.log('Generating contract preview');
            generateContractPreview(moduleClass, config);
        });
    }
}
function downloadFromUrl(url, filename) {
    return __awaiter(this, void 0, void 0, function () {
        var r, name, blob, objUrl, a;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url)];
                case 1:
                    r = _a.sent();
                    if (!r.ok)
                        throw new Error("Download failed (".concat(r.status, ")"));
                    name = filename || decodeURIComponent((url.split('/').pop() || 'contract.pdf').split('?')[0]);
                    return [4 /*yield*/, r.blob()];
                case 2:
                    blob = _a.sent();
                    objUrl = URL.createObjectURL(blob);
                    a = document.createElement('a');
                    a.href = objUrl;
                    a.download = name;
                    a.rel = 'noopener';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(objUrl);
                    return [2 /*return*/];
            }
        });
    });
}
function generateContractPreview(module, config) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var allData = (0, input_output_module_const_1.ValidateFieldsInModule)(module, {
        mappings: input_mapping_const_1._AllMappings,
        showErrors: false,
        showSuccess: false,
    }, false);
    var body = allData.data;
    var accountHolder = (_b = (_a = body.customer.bankAccount) === null || _a === void 0 ? void 0 : _a.accountHolder) === null || _b === void 0 ? void 0 : _b.trim();
    var iban = (_d = (_c = body.customer.bankAccount) === null || _c === void 0 ? void 0 : _c.iban) === null || _d === void 0 ? void 0 : _d.trim();
    var hasSetAccountHolder = !!(accountHolder === null || accountHolder === void 0 ? void 0 : accountHolder.length);
    var hasSetIban = !!(iban === null || iban === void 0 ? void 0 : iban.length) && (0, validate_iban_1.validateIbanValue)(iban).state === 'valid';
    var bankAccount = hasSetAccountHolder && hasSetIban
        ? {
            accountHolder: accountHolder,
            iban: iban,
        }
        : undefined;
    var memberCreation = {
        tenantKey: (_e = config.get) === null || _e === void 0 ? void 0 : _e.tenantKey,
        fittecId: (_f = config.get) === null || _f === void 0 ? void 0 : _f.fittecId,
        referralCode: body.customer.referralCode,
        voucherCode: body.voucherCode,
        dateOfBirth: ((_g = body.customer.dateOfBirth) === null || _g === void 0 ? void 0 : _g.length) ? body.customer.dateOfBirth : '1990-01-01',
        email: body.customer.email,
        givenName: body.customer.firstname,
        familyName: body.customer.lastname,
        gender: ((_h = body.customer.gender) === null || _h === void 0 ? void 0 : _h.length) ? body.customer.gender : 'UNISEX',
        phone: body.customer.telephone_mobile,
        studioId: (_j = localStorage.getItem(input_mapping_const_1._AllMappings.studioId.uid)) !== null && _j !== void 0 ? _j : '',
        studioName: '',
        dateOfBirthNum: new Date(((_k = body.customer.dateOfBirth) === null || _k === void 0 ? void 0 : _k.length) ? body.customer.dateOfBirth : '1990-01-01').getTime(),
        member: __assign({ address: {
                city: ((_l = body.customer.city) === null || _l === void 0 ? void 0 : _l.length) ? body.customer.city : '-',
                postalCode: ((_m = body.customer.zipCode) === null || _m === void 0 ? void 0 : _m.length) ? body.customer.zipCode : '-',
                street: ((_o = body.customer.street) === null || _o === void 0 ? void 0 : _o.length) ? body.customer.street : '-',
                houseNumber: ((_p = body.customer.houseNumber) === null || _p === void 0 ? void 0 : _p.length) ? body.customer.houseNumber : '-',
                countryCode: ((_q = body.customer.countryCode) === null || _q === void 0 ? void 0 : _q.length) ? body.customer.countryCode : 'DE',
            } }, (((_r = body.customer.taxId) === null || _r === void 0 ? void 0 : _r.length) ? { taxId: body.customer.taxId } : {})),
        contractData: {
            rateBundleTermId: (_s = body.contract.rateBundleTermId) === null || _s === void 0 ? void 0 : _s.toString(),
            startDate: body.contract.startDate,
            preuseDate: body.contract.preuseDate,
            selectedRateBundleModules: (_t = body.contract.selectedRateBundleModules) !== null && _t !== void 0 ? _t : [],
            optionalRateBundleTermModules: (_u = body.contract.optionalRateBundleTermModules) !== null && _u !== void 0 ? _u : [],
            notes: body.contract.notes,
        },
        bankAccount: bankAccount !== null && bankAccount !== void 0 ? bankAccount : {
            accountHolder: '-',
            iban: payment_const_1._FakeIBAN.iban,
        },
        paymentChoice: bankAccount ? 'DIRECT_DEBIT' : 'CASH', // DIRECT_DEBIT requires valid bank account
        source: 'fms',
        funnelConfigId: '',
    };
    (0, generator_const_1._CreateLoadingScreen)();
    return (0, backend_services_1.betterFetch)((0, infrastructure_const_1._GetCloudFunctionUrl)('fms') + '/fms/contract-templates/generate-contract-preview', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(memberCreation),
    })
        .then(function (createResponse) { return __awaiter(_this, void 0, void 0, function () {
        var previewResult;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (0, generator_const_1._DeleteLoadingScreen)();
                    if (!createResponse.ok) {
                        return [2 /*return*/, Promise.reject(createResponse.json())];
                    }
                    return [4 /*yield*/, createResponse.json()];
                case 1:
                    previewResult = (_b.sent());
                    if (!((_a = previewResult.url) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, downloadFromUrl(previewResult.url, 'contract preview.pdf')];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/, previewResult];
            }
        });
    }); })
        .catch(function (createdErr) { return __awaiter(_this, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, generator_const_1._DeleteLoadingScreen)();
                    return [4 /*yield*/, createdErr];
                case 1:
                    error = _a.sent();
                    if (error.message) {
                        (0, generator_const_1._ShowErrorMessage)(error.message);
                    }
                    throw error;
            }
        });
    }); });
}
exports.ContractPreviewService = { initElement: initElement };
